<div class="container-fluid">
        <div class="row" id="knowledgebase_container">
          <div class="col-lg-9 col-xl-10 col-md-12 col-xs-12 col-sm-12 col-12 selfhelp_navbar" ></div>
          <div class="col-lg-3 col-xl-2"></div>
        </div>
        <div class="row mt-2">
          <div class="col-lg-9 col-xl-9 col-md-12 col-xs-12 col-sm-12 col-12">
           <zsd-knowledgebasedetail></zsd-knowledgebasedetail>
          </div>
          <div class="col-lg-3 col-xl-3 d-none d-lg-block">
            <zsd-relatedknowledgebase></zsd-relatedknowledgebase>
        </div>
        </div>
      </div>
      <router-outlet></router-outlet>
      